import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { RegisterComponent } from './register/register.component';
import { urlRoutes } from 'src/app/core/constants/url-route.constant';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AuthenticationComponent } from './authentication.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { SigninSignupComponent } from './signin-signup/signin-signup.component';
import { SharedModule } from 'src/app/core/shared-modules/shared.module';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { ConfirmMailComponent } from './confirm-mail/confirm-mail.component';

const routes: Routes = [
    {
        path: '',
        component: AuthenticationComponent,
        children: [
            {
                path: urlRoutes.login,
                component: LoginComponent,
            },
            {
                path: urlRoutes.registration,
                component: RegisterComponent,
            },
            {
                path: urlRoutes.forgotPassword,
                component: ForgotPasswordComponent,
            },
            {
                path: urlRoutes.resetPassword,
                component: ResetPasswordComponent,
            },
            {
                path: urlRoutes.signin,
                component: SigninSignupComponent,
            },
        ],
    },
];

@NgModule({
    declarations: [
        LoginComponent,
        RegisterComponent,
        ForgotPasswordComponent,
        SigninSignupComponent,
        ResetPasswordComponent,
        AuthenticationComponent,
        ConfirmMailComponent,
    ],
    imports: [
        CommonModule,
        RouterModule.forChild(routes),
        FormsModule,
        ReactiveFormsModule,
        SharedModule
    ],
    exports: [
        LoginComponent,
        RegisterComponent,
        ForgotPasswordComponent,
        SigninSignupComponent,
        RouterModule,
    ],
})
export class AuthenticationModule {}
